import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { signOut } from "../SignIn/actions";
import history from "../../utils/history";
import { runInThisContext } from "vm";

export default function(ComposedComponent, checkAuthorization = true) {
  class Authorization extends Component {
    constructor(props) {
      super(props);
      this.state = {
        show: true
      };
    }

    static contextTypes = {
      router: PropTypes.object
    };

    componentWillMount() {
      let url = `${this.props.match.path}`;
      if (!this.props.authenticated) {
        history.push(`${window.FOLDER}/signin`);
        this.props.signOut();
        this.setState({ show: false });
      } else {
        if (
          !this.props.user
            .get("modulos")
            .filter(
              x =>
                x
                  .get("submodulos")
                  .filter(
                    y => `${window.FOLDER}${y.getIn(["config", "url"])}` === url
                  )
                  .count() > 0 ||
                `${window.FOLDER}${x.getIn(["config", "url"])}` === url
            )
            .count()
        ) {
          this.setState({ show: false });
          history.push(`${window.FOLDER}/unauthorized`);
        }
      }
    }

    componentWillUpdate(nextProps) {
      let url = `${this.props.match.path}`;
      // url = url.replace(/\{\w+\}/g, ":$1");

      if (!nextProps.authenticated) {
        history.push(`${window.FOLDER}/signin`);
        this.props.signOut();
        this.setState({ show: false });
      } else {
        if (
          !nextProps.user
            .get("modulos")
            .filter(
              x =>
                x
                  .get("submodulos")
                  .filter(
                    y => `${window.FOLDER}${y.getIn(["config", "url"])}` === url
                  )
                  .count() > 0 ||
                `${window.FOLDER}${x.getIn(["config", "url"])}` === url
            )
            .count()
        ) {
          history.push(`${window.FOLDER}/unauthorized`);
          this.setState({ show: false });
        }
      }
    }

    render() {
      if (this.state.show) {
        return <ComposedComponent {...this.props} />;
      } else {
        return null;
      }
    }
  }

  function mapStateToProps(state) {
    return {
      authenticated: state.signin.get("isAuthenticated"),
      user: state.signin.get("user")
    };
  }

  const mapDispatchToProps = dispatch => {
    return {
      signOut: () => dispatch(signOut())
    };
  };

  return connect(mapStateToProps, mapDispatchToProps)(Authorization);
}
